import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { compactMap, filterFilms, filterShowtimes, FilterType, getFilmById, getFilteredSubscriptionBillingOptions, getShowtimeById } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useI18n } from '../../../context/occ/hooks/use-i18n';
import { Button } from '../../../subcomponents/button/button';
import { ButtonColor } from '../../../subcomponents/button/types/color';
const b = bemClassBuilder('v-composite-filter-modal-footer');
export const CompositeFilterModalFooter = observer(props => {
    const i18n = useI18n();
    const { displayText, filter, hasFiltersApplied } = props;
    const getResultMessage = () => {
        if (!hasFiltersApplied) {
            return displayText.selectFiltersMessage;
        }
        const count = getResultCount(filter);
        return i18n.template(displayText.resultCountMessage, { count });
    };
    return (_jsxs("div", Object.assign({ className: b.block() }, { children: [_jsx("p", Object.assign({ className: b.element('message', {
                    filtersApplied: hasFiltersApplied
                }) }, { children: getResultMessage() })), _jsx("div", { className: b.element('line') }), _jsxs("div", Object.assign({ className: b.element('buttons') }, { children: [_jsx("div", Object.assign({ className: b.element('other-button-group') }, { children: hasFiltersApplied && (_jsx(Button, Object.assign({ className: b.element('clear-button'), color: ButtonColor.Secondary, type: "reset", onClick: props.onClear }, { children: displayText.modalClearFiltersButtonLabel }))) })), _jsxs("div", Object.assign({ className: b.element('main-button-group') }, { children: [_jsx(Button, Object.assign({ className: b.element('cancel-button'), color: ButtonColor.Secondary, onClick: props.onCancel }, { children: displayText.modalCancelButtonLabel })), _jsx(Button, Object.assign({ className: b.element('apply-button'), color: ButtonColor.Primary, type: "submit", onClick: props.onApply }, { children: displayText.modalApplyButtonLabel }))] }))] }))] })));
});
CompositeFilterModalFooter.displayName = 'CompositeFilterModalFooter';
const getResultCount = (filter) => {
    switch (filter.type) {
        case FilterType.Film: {
            const allFilms = compactMap(filter.baseData, getFilmById);
            return filterFilms(filter, allFilms).length;
        }
        case FilterType.Showtime: {
            const allShowtimes = compactMap(filter.baseData, getShowtimeById);
            return filterShowtimes(filter, allShowtimes).length;
        }
        case FilterType.Subscription: {
            return getFilteredSubscriptionBillingOptions(filter).length;
        }
        default:
            return 0;
    }
};
